module.exports = __webpack_public_path__ + "static/media/bg.ebbdd2b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/auth/containers/bg.jpg
// module id = 705
// module chunks = 0